(function () {
  //–– CONFIG & STATE ––//
  const MAX_ITEMS = 6;
  const customBundle = [];
  const bundleTotalEl = document.getElementById("bundle-total");
  const submitBtn = document.getElementById("submit-bundle-btn");

  //–– UTILS ––//
  const toast = (icon, title, ms = 3000) =>
    Swal.fire({
      toast: true,
      position: "top-end",
      icon,
      title,
      showConfirmButton: false,
      timer: ms,
    });

  const makeGroupId = () =>
    `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

  function getSectionInnerHTML(html, selector = ".shopify-section") {
    try {
      return (
        new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector)?.innerHTML || ""
      );
    } catch {
      return "";
    }
  }

  //–– BUNDLE LOGIC ––//
  function addToBundle(e) {
    e.preventDefault();
    const btn = e.currentTarget;
    const productItem = btn.closest(".product-item");
    const inputs = productItem.querySelectorAll(".bundle-product-data");
    console.log(inputs);
    const isGroup = productItem.querySelector(".has-bundle-products");
    const basePrice = parseInt(btn.dataset.productPrice, 10) / 100;
    const variantId = btn.dataset.variantId;
    console.log(variantId);
    const title = btn.dataset.productTitle;

    // sold out items / 0 in stock product logic
    const isSoldOut = btn.dataset.productStock === "0";
    if (isSoldOut) {
      return toast("error", `${title} is sold out!`);
    }

    // check capacity
const needed = isGroup ? inputs.length : 1;
const availableSpace = MAX_ITEMS - customBundle.length;

if (availableSpace === 0) {
  return toast("info", "Bundle is full. Cannot add more items.");
}

if (customBundle.length + needed > MAX_ITEMS) {
  return toast(
    "error",
    `Not enough space! Need ${needed}, but only ${availableSpace} slot${availableSpace === 1 ? "" : "s"} available.`
  );
}

    // for featured image
    // if (isGroup) {
    //   const groupId = makeGroupId();
    //   inputs.forEach((input) => {
    //     const itemPrice = parseFloat(input.dataset.productPrice || 0) / 100;
    //     console.log(input);
    //     console.log(itemPrice);
    //     customBundle.push({
    //       id: input.value,
    //       parentId: variantId,
    //       title,
    //       price: itemPrice,
    //       imageSrc: input.dataset.productImages,
    //       bundleGroupId: null,
    //     });
    //   });
    // } else {
    //   customBundle.push({
    //     id: variantId,
    //     title,
    //     price: basePrice,
    //     imageSrc: productItem.querySelector("img").src,
    //     bundleGroupId: null,
    //   });
    // }

    // for secondary or other image
    // if (isGroup) {
    //   const groupId = makeGroupId();
    //   inputs.forEach((input) => {
    //     const images = JSON.parse(input.dataset.productImages);
    //     const imageSrc = images[1] || images[0];
    //     const itemPrice = parseFloat(input.dataset.productPrice || 0) / 100;
    //     customBundle.push({
    //       id: input.value,
    //       parentId: variantId,
    //       title,
    //       price: itemPrice,
    //       imageSrc,
    //       bundleGroupId: groupId,
    //     });
    //   });
    // } else {
    //   customBundle.push({
    //     id: variantId,
    //     title,
    //     price: basePrice,
    //     imageSrc: productItem.querySelector("img").src,
    //     bundleGroupId: null,
    //   });
    // }


    // for metafield image
    if (isGroup) {
  const groupId = makeGroupId();
  inputs.forEach((input) => {
    const imageSrc = input.dataset.productImage;
    const itemPrice = parseFloat(input.dataset.productPrice || 0) / 100;

    customBundle.push({
      id: input.value,
      parentId: variantId,
      title,
      price: itemPrice,
      imageSrc, 
      bundleGroupId: groupId,
    });
  });
} else {  
  customBundle.push({
    id: variantId,
    title,
    price: basePrice,
    imageSrc:productItem.querySelector("img").src,
    bundleGroupId: null,
  });
}
    updateBundleUI();
  }

  // remove Bundle Items
  // async function removeAllBundleItems() {
  //   const btn = document.getElementById("remove-all-bundles");
  //   if (!btn) return;
  //   btn.disabled = true;
  //   btn.textContent = "Removing…";

  //   try {
  //     const cart = await fetch(`${Shopify.routes.root}cart.js`, {
  //       headers: { Accept: "application/json" },
  //     }).then((r) => r.json());

  //     const updates = {};
  //     cart.items.forEach((item) => {
  //       updates[item.key] =
  //         item.properties?.["Bundle Item"] === "Yes" ? 0 : item.quantity;
  //     });

  //     const data = await fetch(`${Shopify.routes.root}cart/update.js`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //       body: JSON.stringify({
  //         updates,
  //         sections: "cart-icon-bubble,cart-drawer",
  //       }),
  //     }).then((r) => r.json());

  //     const bubbleEl = document.querySelector("#cart-icon-bubble");
  //     if (bubbleEl && data.sections?.["cart-icon-bubble"]) {
  //       bubbleEl.innerHTML = getSectionInnerHTML(
  //         data.sections["cart-icon-bubble"]
  //       );
  //     }

  //     const drawerEl = document.querySelector("cart-drawer");
  //     if (drawerEl && data.sections?.["cart-drawer"]) {
  //       const parser = new DOMParser();
  //       const frag = parser.parseFromString(
  //         data.sections["cart-drawer"],
  //         "text/html"
  //       );
  //       const newEl = frag.querySelector("cart-drawer");
  //       if (newEl) drawerEl.innerHTML = newEl.innerHTML;
  //     }

  //     const wrapper = document.querySelector(".drawer");
  //     if (wrapper) {
  //       wrapper.classList.toggle("is-empty", data.item_count === 0);
  //     }
  //     document
  //       .querySelector("#CartDrawer-Overlay")
  //       ?.addEventListener("click", () => wrapper?.close());

  //     Swal.fire({
  //       toast: true,
  //       position: "top-end",
  //       icon: "success",
  //       title: "All bundle items removed",
  //       showConfirmButton: false,
  //       timer: 3000,
  //     });
  //   } catch (err) {
  //     console.error("removeAllBundleItems error:", err);
  //     Swal.fire({
  //       toast: true,
  //       position: "top-end",
  //       icon: "error",
  //       title: "Failed to remove bundle items",
  //       showConfirmButton: false,
  //       timer: 3000,
  //     });
  //   } finally {
  //     btn.disabled = false;
  //     btn.textContent = "Remove Bundle Items";
  //   }
  // }

  // document.addEventListener("click", (e) => {
  //   if (e.target.matches("#remove-all-bundles")) {
  //     removeAllBundleItems();
  //   }
  // });

  // update bundle UI
  function updateBundleUI() {
    const bundleList = document.querySelector(".bundle-list");
    document.querySelectorAll(".bundle-list li").forEach((li, i) => {
      li.innerHTML = "";
      const item = customBundle[i];
      if (!item) return;

      const img = document.createElement("img");
      img.src = item.imageSrc;
      img.alt = item.title;

      const btn = document.createElement("button");
      // btn.innerHTML = "";
      btn.addEventListener("click", () => {
        customBundle.splice(i, 1);
        updateBundleUI();
      });

      li.appendChild(img);
      li.appendChild(btn);
    });

    // Calculate the total price of the bundle
    // const bundleTotalPrice = customBundle.reduce(
    //   (total, item) => total + item.price,
    //   0
    // );

    // window.bundleTotalPrice = bundleTotalPrice;
    // bundleTotalEl.textContent = `$${bundleTotalPrice.toFixed(2)}`;

    if (customBundle.length === MAX_ITEMS) {
      toast("info", "Bundle is full");
    }
  }

  // submit Bundled items to cart drawer
  function submitBundle(e) {
    e.preventDefault();
    const remaining = MAX_ITEMS - customBundle.length;
    if (remaining > 0) {
      return toast(
        "warning",
        `Please select ${remaining} more item${remaining > 1 ? "s" : ""}.`
      );
    }

    submitBtn.disabled = true;
    submitBtn.innerText = "ORDERING...";

    const itemsToAdd = customBundle.map((item) => ({
      id: item.id,
      quantity: 1,
      properties: {
        // "Bundle Item": "Yes",
        "bundle_image": item.imageSrc, 
      },
    }));

    console.log("Ordering cart:", itemsToAdd);
    // console.log(bundleTotalPrice);

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: itemsToAdd,
        sections: "cart-icon-bubble,cart-drawer,main-cart-items",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.sections?.["cart-icon-bubble"]) {
          document.querySelector("#cart-icon-bubble").innerHTML =
            getSectionInnerHTML(data.sections["cart-icon-bubble"]);
        }

        if (data.sections?.["cart-drawer"]) {
          const parser = new DOMParser();
          const frag = parser.parseFromString(
            data.sections["cart-drawer"],
            "text/html"
          );
          const newDrawer = frag.querySelector("cart-drawer");
          const oldDrawer = document.querySelector("cart-drawer");
          if (newDrawer && oldDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
        }

        const mainDr = document.querySelector(".drawer");
        const cartIt = document.querySelector("cart-drawer-items");
        if (mainDr) {
          mainDr.classList.toggle(
            "is-empty",
            cartIt?.classList.contains("is-empty")
          );
          mainDr.open();
        }

        document
          .querySelector("#CartDrawer-Overlay")
          ?.addEventListener("click", () => mainDr?.close());

        customBundle.length = 0;
        updateBundleUI();
      })
      .catch(() => toast("error", "Failed to add bundle to cart."))
      .finally(() => {
        submitBtn.disabled = false;
        submitBtn.innerText = "Order Bundle";
      });
  }

  //–– INIT ––//
  document
    .querySelectorAll(".add-to-bundle-btn,  .bundle-image-clickable")
    .forEach((btn) => btn.addEventListener("click", addToBundle));

  submitBtn.addEventListener("click", submitBundle);

  //–– GSAP STUFF ––//
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);
    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".gs-bundle-heading-wrapper",
          start: "20% 20%",
          end: "60% center",
          scrub: 1,
          // markers: true,
        },
      })
      .fromTo(
        ".gs-bundle-heading-wrapper span",
        { y: 40 },
        { y: 0, opacity: 1, ease: "power2.out" }
      )
      .to(".gs-bundle-heading-wrapper img", {
        scale: 1,
        duration: 1,
        ease: "power2.out",
      });

    ScrollTrigger.create({
      trigger: "#custom-bundle-container",
      start: "top top",
      // end: () => document.documentElement.scrollHeight - window.innerHeight,
      // pin: "#custom-bundle-container",
      // pinSpacing: false,
      onEnter: function() {
        document.querySelector('#custom-bundle-container').classList.add('scroll-active');
        document.querySelector('.sticky-header--on-scroll').style.background = "#efd9ce";
      },
      onLeaveBack: function() {
        document.querySelector('#custom-bundle-container').classList.remove('scroll-active');
        document.querySelector('.sticky-header--on-scroll').style.background = "transparent";
      }
    });
  });
})();
